import StartUp from "../../assets/images/svg/startup.svg";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="mt-md-4 slide-in-left">
              <div>
                <span className="badge bg-success rounded-pill pulse-animation">
                  OrderRun
                </span>
                <span className="text-white-50 ms-1">
                  Complete Business Management
                </span>
              </div>
              <h1
                className="text-white fw-bold mb-4 mt-3 hero-title"
                style={{ fontSize: "3rem" }}
              >
                Streamline Your Sportswear Manufacturing
              </h1>

              <p className="mb-4 font-16 text-white-50 lead">
                OrderRun is a comprehensive solution designed specifically
                for sportswear manufacturers. Manage leads, customers, quotes,
                work orders, inventory, and production—all in one powerful
                platform.
              </p>

              <div className="d-flex gap-3 flex-wrap">
                <Link
                  to="/app/client-login"
                  className="btn btn-success btn-lg rounded-pill px-4 shadow-lg"
                >
                  Get Started <i className="mdi mdi-arrow-right ms-1"></i>
                </Link>
                <a
                  href="#features"
                  className="btn btn-outline-light text-white-hover btn-lg rounded-pill px-4"
                >
                  Learn More <i className="mdi mdi-chevron-down ms-1"></i>
                </a>
              </div>

              <div className="mt-4 d-flex gap-4 flex-wrap">
                <div className="text-white-50">
                  <i className="mdi mdi-check-circle text-success me-2"></i>
                  <small>Free 30-day trial</small>
                </div>
                <div className="text-white-50">
                  <i className="mdi mdi-check-circle text-success me-2"></i>
                  <small>No credit card required</small>
                </div>
                <div className="text-white-50">
                  <i className="mdi mdi-check-circle text-success me-2"></i>
                  <small>24/7 Support</small>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="text-md-end mt-3 mt-md-0 slide-in-right">
              <img
                src={StartUp}
                alt="OrderRun"
                className="img-fluid pulse-animation"
                style={{ maxHeight: "500px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
